import { Form, Input, Typography } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import styled from 'styled-components'

const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`

export interface FlowCytometryReviewAnalysisConfigurationFormValues {
  visitCode: string
  tubeName?: string
  drugSpike?: string
  experimentId: string
  additionalExperimentIds: string
  ssrExperimentId: string
}

const FlowCytometryReviewAnalysisConfigurationModalSampleStep = memo(() => {
  return (
    <>
      <Section>
        <Typography.Text strong>
          {t('reviewAnalysisConfigurationModal.sections.initialSample.title')}
        </Typography.Text>
        <Form.Item
          name="visitCode"
          label={t('reviewAnalysisConfigurationModal.sections.initialSample.title')}
          extra={t('reviewAnalysisConfigurationModal.fields.initialSample.helperText')}
          rules={[
            {
              required: true,
              whitespace: true,
              message: t('reviewAnalysisConfigurationModal.validation.required'),
            },
          ]}
          style={{ marginBottom: 12 }}
        >
          <Input
            placeholder={t(
              'reviewAnalysisConfigurationModal.fields.initialSample.visitCode.placeholder'
            )}
          />
        </Form.Item>
      </Section>

      <Section>
        <Form.Item
          name="tubeName"
          label={t('reviewAnalysisConfigurationModal.sample.tubeName.label')}
          style={{ marginBottom: 12 }}
        >
          <Input
            placeholder={t(
              'reviewAnalysisConfigurationModal.sample.tubeName.placeholder'
            )}
          />
        </Form.Item>
      </Section>

      <Section>
        <Form.Item
          name="drugSpike"
          label={t('reviewAnalysisConfigurationModal.sample.drugSpike.label')}
          style={{ marginBottom: 0 }}
        >
          <Input
            placeholder={t(
              'reviewAnalysisConfigurationModal.sample.drugSpike.placeholder'
            )}
          />
        </Form.Item>
      </Section>
    </>
  )
})

export default FlowCytometryReviewAnalysisConfigurationModalSampleStep

